export default "__VITE_ASSET__TrmCtGrh__"